import { render, staticRenderFns } from "./servicePoints.vue?vue&type=template&id=06f99a6c&scoped=true"
import script from "./servicePoints.vue?vue&type=script&lang=js"
export * from "./servicePoints.vue?vue&type=script&lang=js"
import style0 from "./servicePoints.vue?vue&type=style&index=0&id=06f99a6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f99a6c",
  null
  
)

export default component.exports